export enum NotificationTypes {
  WinnerNotification = "winnerticket",
  NewRechargeNotification = "newrecharge",
  AwardPaymentNotification = "awardpayment",
  AutorechargeNotification = "autorecharge",
  WithdrawalFinished = "withdrawal.finished",

}
